import { render, staticRenderFns } from "./HeaderPrestigeGroup.vue?vue&type=template&id=05a7d691&scoped=true"
import script from "./HeaderPrestigeGroup.vue?vue&type=script&lang=js"
export * from "./HeaderPrestigeGroup.vue?vue&type=script&lang=js"
import style0 from "./HeaderPrestigeGroup.vue?vue&type=style&index=0&id=05a7d691&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a7d691",
  null
  
)

export default component.exports